module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/203.8be1d14d.png";